import { frontendURL } from 'dashboard/helper/URLHelper';
import store from 'dashboard/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { resolveLuciAgentRouteAccess } from './access';

export const luciAgentBeforeEnter = to =>
  resolveLuciAgentRouteAccess(to, store.getters.getCurrentUser);

export const routes = [
  {
    path: frontendURL('accounts/:accountId/luci'),
    name: 'luci_agent_index',
    component: () => import('./Index.vue'),
    meta: {
      featureFlag: FEATURE_FLAGS.LUCI_CONVERSATION_CONTROL,
      permissions: ['administrator'],
    },
    beforeEnter: luciAgentBeforeEnter,
  },
];
